export const join = [
  {
    icon: "Inclusive-Environment.png",
    heading: "Inclusive Environment",
    text: "Diverse and inclusive teams that thrive on mutual respect, creativity, and collaborative spirit",
  },
  {
    icon: "Career-Development.png",
    heading: "Career Development",
    text: "We offer continuous learning opportunities to help you grow in your career",
  },
  {
    icon: "Innovative-Culture.png",
    heading: "Innovative Culture",
    text: "Be part of a team that fosters creativity, encourages innovation, and embraces new ideas",
  },
  {
    icon: "Cutting-Edge-Technology.png",
    heading: "Cutting-Edge Technology",
    text: "Access to the latest tools and technology to help you excel in your role and stay ahead in your field",
  },
];
